import { GenericMapping, GenericMappingType } from '../../search/types'

export const LINEAR_GENERIC_MAPPINGS: GenericMapping[] = [
  {
    key: 'archivedAt',
    type: GenericMappingType.DATE,
    name: 'Archival date',
    description: 'The date and time the issue was archived',
  },
  {
    key: 'assignee',
    type: GenericMappingType.KEYWORD,
    name: 'Assignee',
    description: 'Member assigned to the issue',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'canceledAt',
    type: GenericMappingType.DATE,
    name: 'Cancellation date',
    description: 'The date and time the issue was cancelled',
  },
  {
    key: 'completedAt',
    type: GenericMappingType.DATE,
    name: 'Completion date',
    description: 'The date and time the issue was completed',
  },
  {
    key: 'creator',
    type: GenericMappingType.KEYWORD,
    name: 'Creator',
    description: 'The user who created the issue',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'estimate',
    type: GenericMappingType.NUMBER,
    name: 'Estimate',
    description: 'Number to estimate the complexity of the issue',
  },
  {
    key: 'labels',
    type: GenericMappingType.KEYWORD,
    name: 'Labels',
    description: 'Labels set on the issue',
    enumFromTermsAggEsQuery: true,
  },
  {
    key: 'priority',
    type: GenericMappingType.KEYWORD,
    name: 'Priority',
    description: 'The priority of the issue',
    enum: ['No priority', 'Low', 'Medium', 'High'],
  },
  {
    key: 'state',
    type: GenericMappingType.KEYWORD,
    name: 'State',
    description: 'The state of the issue',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'cycle',
    type: GenericMappingType.KEYWORD,
    name: 'Cycle',
    description: 'The cycle name the issue is associated with',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'cycleNumber',
    type: GenericMappingType.NUMBER,
    name: 'Cycle number',
    description:
      'The numeric cycle representation the issue is associated with',
  },
  {
    key: 'identifier',
    type: GenericMappingType.KEYWORD,
    name: 'Identifier',
    description: 'Human readable issue identifier',
  },
  {
    key: 'team',
    type: GenericMappingType.KEYWORD,
    name: 'Team',
    description: 'The team the issue is associated with',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'project',
    type: GenericMappingType.KEYWORD,
    name: 'Project',
    description: 'The project the issue is associated with',
    enumFromCollapseEsQuery: true,
  },
] as const
